export default {
  general: {
    shopName: '',
    notificationEmail: '',
    // questionFromEmail: '',
    fromEmail: '',
    shopOwnerName: '',
    hideAllOpinewWidgets: false,
    customCss: '',
    logoUrl: '',
    autoReplaceObfuscatedReviewerNames: true,
    showReviewsFromArchivedProducts: false,
    dashboardLanguage: '',
    qAndAActive: false,
    deactivateEmailNotifications: false,
    emailTranslationEnabled: false,
  },
  reviews: {
    reviewPublishing: '',
  },
  reviewRequests: {
    sendReviewRequests: false,
    requestSequenceAdvancedView: false,
    sendReviewRequestsKlaviyo: false,
    sendPhotoRequests: false,
    sendPhotoRequestWaitDays: false,
    photoRequestStarSubset: 1,
    dontSendToRepeatCustomers: false,
    postPurchaseEmailDays: '',
    postPurchaseEmailDaysInternational: '',
    postPurchaseEmailDaysPosOrder: '',
    resendReviewRequests: '',
    resendEmailWaitDays: '',
    postPurchaseEmailSendAtHour: '',
    postPurchaseEmailSendAtMinute: '',
    blacklistedReviewRequestEmails: '',
    emailDomain: '',
    emailSubdomain: '',
    emailRecords: [],
    sendReviewRequestsOmnisend: false,
    advancedReviewRequestsEmailTemplateActive: false,
    advancedCouponEmailTemplateActive: false,
    advancedUnverifiedReviewTemplateActive: false,
    advancedPhotoRequestsEmailTemplateActive: false,
    requestFormStarsColor: '',
    requestFormImageUrl: '',
    requestFormCustomCss: '',
    sendOnlyReviewRequestsSms: false,
    reviewRequestExcludedProducts: [],
  },
  reviewImporting: {
    importsAutomaticSync: false,
    importedReviewAutoApprove: true,
    importerProfiles: {},
  },
  other: {
    reportsFrequency: 'fortnightly',
  },
};
